import { ApiResponse, postRequest } from "@/data/apiClient";
import config from "@/config";

export const logUserActivity = async (
  page: string
): Promise<ApiResponse<void>> =>
  config.BASE_API_URL
    ? postRequest("logUserActivity", { page, application: 'Accounts' })
    : postRequest("/api/logUserActivity", { page, application: 'Accounts' });
